// extracted by mini-css-extract-plugin
export default {"smsConfirmationContainer":"SmsConfirmation-module__smsConfirmationContainer___3zHnw"};